import { render, staticRenderFns } from "./CoverPicture.vue?vue&type=template&id=072c348e&scoped=true&"
import script from "./CoverPicture.vue?vue&type=script&lang=js&"
export * from "./CoverPicture.vue?vue&type=script&lang=js&"
import style0 from "./CoverPicture.vue?vue&type=style&index=0&id=072c348e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c348e",
  null
  
)

export default component.exports